module.exports = function() {
  return new Worker(__webpack_public_path__ + "a601212ab485334e1910.worker.js");
};